<template>
  <div>
    <div class="mt-3" v-for="(page, pageIndex) in summaryTable" :key="`summary-page-${pageIndex}`">
      <div :id="`summary_${sheetType}_${inspectionId}_${pageIndex}`" class="report sheet sheet-summary border rounded">
        <article class="px-3 py-5 bg-white" :class="{ transparent: isLoading }">
          <p class="mb-4 summary-title text-center">{{ sheetType }} Report Summary</p>
          <table class="table table-bordered table-summary mb-0 text-center">
            <thead>
              <tr>
                <th colspan="7" class="font-weight-bold table-head">
                  {{ sheetType }} INSPECTION
                </th>
              </tr>
              <tr>
                <th class="table-subhead">NO</th>
                <th class="table-subhead">DATE</th>
                <th class="table-subhead">POLE NO</th>
                <th class="table-subhead">COMPONENT</th>
                <th class="table-subhead">DEFECT</th>
                <th class="table-subhead" v-if="sheetType == 'thermal'">
                  ∆T (°C)
                </th>
                <th class="table-subhead">SEVERITY</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, rowIndex) in page" :key="`summary-table-${row.id}`">
                <td>{{ (pageIndex * 20) + (rowIndex + 1) }}</td>
                <td>{{ dateFormat('date', row.date) }}</td>
                <td>{{ row.pole_no }}</td>
                <td>{{ row.component }}</td>
                <td>{{ row.defect }}</td>
                <td v-if="sheetType == 'thermal'">
                  {{ row.deltaT }}
                </td>
                <td :class="getRowClass(row.severity)">
                  {{ row.severity.toUpperCase() == 'CAUTIOUS' ? 'MINOR' : row.severity }}
                </td>
              </tr>
              <tr>
                <td colspan="7" class="text-center text-muted" v-if="!summaryTable.length">
                  No defect found
                </td>
              </tr>
            </tbody>
          </table>
        </article>
        <loading-spinner class="loading-spinner-component" v-if="isLoading"></loading-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment";
import LoadingSpinner from "@/components/LoadingSpinner";

export default {
  name: "reportSheetSummary",
  props: [
    "inspectionId",
    "sheetType",
    "summaryTable",
    "category"
  ],
  components: {
    "loading-spinner": LoadingSpinner,
  },
  data() {
    return {
      isLoading: false
    };
  },
  watch: {
    inspectionId: {
      async handler() {
        if (this.inspectionId) {
          this.resizeSummarySheet();
        }
      },
      immediate: true,
    },
  },
  methods: {
    dateFormat(type, date) {
      if (date) {
        if (type === "date") {
          return moment.utc(date).format("DD/MM/YYYY");
        } else if (type === "time") {
          return moment.utc(date).format("h:mm A");
        } else {
          return date;
        }
      } else {
        return "";
      }
    },
    resizeSummarySheet(skipTimeout) {
      this.isLoading = skipTimeout ? false : true;
      setTimeout(
        () => {
          const sheets = $('.sheet-summary');
          sheets.each((_, sheet) => {
            const $sheet = $(sheet);
            const sheetWidth = $sheet.width();

            $sheet.height(sheetWidth * 1.2414285714);
            $sheet.css({
              fontSize: sheetWidth * 0.01326119403,
            });

            const title = $sheet.find('.summary-title');

            title.css({
              fontSize: sheetWidth * 0.01879104478,
            });
          });

          // let elementId = `#summary_${this.sheetType}_${this.inspectionId}`;
          // const sheet = $(elementId);
          // const sheetWidth = sheet.width();
          // sheet.height(sheetWidth * 1.2414285714);
          // sheet.css({
          //   fontSize: sheetWidth * 0.01326119403,
          // });
          // const title = sheet
          //   .children()
          //   .children(".summary-title");
          // title.css({
          //   fontSize: sheetWidth * 0.01879104478,
          // });

          this.isLoading = false;
        },
        skipTimeout ? 10 : 2000
      );
    },
    getRowClass(severity) {
      let result;

      if (this.category == 'lv') {
        switch (severity?.toLowerCase()) {
          case "low":
            result = "bg-low";
            break;
          case "cautious":
          case "minor":
            result = "bg-minor";
            break;
          case "critical":
            result = "bg-critical";
            break;
          default:
            result = "bg-light";
            break;
        }
      } else {
        switch (severity?.toLowerCase()) {
          case "low":
            result = "bg-low";
            break;
          case "minor":
            result = "bg-normal";
            break;
          case "cautious":
            result = "bg-minor";
            break;
          case "critical":
            result = "bg-critical";
            break;
          default:
            result = "bg-light";
            break;
        }
      }

      return result;
    },
  },
  mounted() {
    $(window).on("resize", (e) => {
      this.resizeSummarySheet(true);
    });
  },
  beforeDestroy() {
    $(window).off("resize");
  },
};
</script>

<style lang="scss" scoped>
@import url("../assets/css/print.scss");

.sheet {
  width: 100% !important;
  height: auto;
  position: relative;

  article {
    width: 100%;
    height: 100%;
    display: block;

    .summary-title {
      font-size: 1.5rem;
      font-weight: 600;
      text-transform: uppercase;
    }

    &.transparent {
      opacity: 0;
    }

    .table-head {
      color: #ffffff !important;
      background-color: #004c9c !important;
      font-weight: 500;
      text-transform: uppercase;
    }

    .table-subhead {
      background-color: #bdd7ee !important;
    }
  }

  .table tr.bg-success {

    th,
    td {
      background-color: #17a2b8 !important;
    }
  }

  .table tr.bg-warning {

    th,
    td {
      background-color: #ffc107 !important;
    }
  }

  .table-summary {

    th,
    td {
      padding: 1%;
    }
  }
}
</style>
